import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const DEFAULT_ACTIONS = {
  continueLabel: "Continue",
  continueDisabled: true,
  onContinue: null,
  footer: null,
  showSave: false,
  saveLabel: "Save",
  saveDisabled: true,
  onSave: null,
};

const OnboardingStepActionsContext = createContext(null);

export function OnboardingStepActionsProvider({ children }) {
  const [actions, setActions] = useState(DEFAULT_ACTIONS);

  const registerStepActions = useCallback((next) => {
    setActions({
      continueLabel: next.continueLabel ?? "Continue",
      continueDisabled: Boolean(next.continueDisabled),
      onContinue: next.onContinue ?? null,
      footer: next.footer ?? null,
      showSave: Boolean(next.showSave),
      saveLabel: next.saveLabel ?? "Save",
      saveDisabled: Boolean(next.saveDisabled),
      onSave: next.onSave ?? null,
    });
  }, []);

  const clearStepActions = useCallback(() => {
    setActions(DEFAULT_ACTIONS);
  }, []);

  const value = useMemo(
    () => ({ actions, registerStepActions, clearStepActions }),
    [actions, registerStepActions, clearStepActions],
  );

  return (
    <OnboardingStepActionsContext.Provider value={value}>
      {children}
    </OnboardingStepActionsContext.Provider>
  );
}

export function useOnboardingStepActions() {
  const context = useContext(OnboardingStepActionsContext);
  if (!context) {
    throw new Error("useOnboardingStepActions must be used within OnboardingStepActionsProvider");
  }
  return context;
}
